import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  roles: any = [];
  orgs: any = [];

  // userInfo = {
  //   ISPID: 120105,
  //   Username: "Shady.abdallah@vodafone.com",
  //   Userstatus: "Activated",
  //   MobileNumber: "01002200020",
  //   UserType: "Internal",
  //   RoleType: "ISPAdmin",
  //   NationalID: "29502220112098"
  // }
  avaRoles: any;
  allIsps: any;

  createUser = new FormGroup({
    username: new FormControl('', [
      Validators.required,
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    displayName: new FormControl('', [
      Validators.required
    ]),
    mobile: new FormControl('', [
      Validators.required,
    ]),
    type: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
    // organization: new FormControl('', [
    //   Validators.required,
    // ]),
    role: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private userService: UserService
    , private roleService: RoleService
    , private orgService: OrgService
  ) {

  }

  changeRole(e: any) {
    this.createUser.value.roleType = e.target.value, {
      onlySelf: true
    }
  }
  ngOnInit(): void {
    this.getAllRoles();
  }

  createUserChange() {

  }

  createUserSubmit() {
    if (this.createUser.valid) {
      let username = this.createUser.controls.username.value
      let email = this.createUser.controls.email.value
      let displayName = this.createUser.controls.displayName.value
      let mobile = this.createUser.controls.mobile.value
      let userType = this.createUser.controls.type.value
      let active = this.createUser.controls.active.value
      // let orgid = this.createUser.controls.organization.value
      let roleId = this.createUser.controls.role.value

      // call your service 
      this.addUser(username, email, displayName, mobile, userType, active
        // , orgid
        , roleId)
    }
    else {
      this.createUser.markAllAsTouched();
      this.createUser.markAsDirty();
    }
  }

  addUser(username: string, email: string, displayName: string, mobile: string, userType: string, active: string
    // , orgid: number
    , roleId: number) {
    this.creating = true;
    let candidateid = 0;
    let studentid = 0;
    let teacherid = 0;
    if (userType == "candidate") {
      candidateid = 1;
    } else if (userType == "student") {
      studentid = 1;
    } else if (userType == "teacher") {
      teacherid = 1;
    }
    let password = "123456";


    this.userService.addUser(username, password, displayName, email, mobile, userType, candidateid, studentid, teacherid, active)
      .subscribe(
        data => {
          // USER ID should be dynamic
          this.addUserRole(data.id, roleId, username
            // , orgid
          );
        },
        error => {
          this.creating = false;
          this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER'));
        }
      );
  }

  getAllRoles() {
    this.showLoader = true;
    this.roleService.getAllRoles().subscribe(
      data => {
        this.roles = data;
        this.getAllOrgs();
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_ROLES"));
        this.showLoader = false;
      }
    );
  }

  getAllOrgs() {
    this.orgService.getAllOrgs().subscribe(
      data => {
        this.orgs = data;
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_ORGS"));
        this.showLoader = false;
      }
    );
  }

  addUserRole(userid: number, roleid: number, username: string
    // , orgid: number
  ) {

    this.userService.addUserRole(userid, roleid, new Date(), new Date, "YES")
      .subscribe(
        data => {
          this.creating = false;
          this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
          this.router.navigate(['/users']);
          // this.addUserOrg(username, orgid, userid);
        },
        error => {
          this.creating = false;
          this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ROLE'));
        }
      );
  }

  // addUserOrg(username: string, orgid: number, userid: number) {

  //   this.userService.addUserOrg(username, orgid, userid)
  //     .subscribe(
  //       data => {
  //         this.creating = false;
  //         this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
  //         this.router.navigate(['/users']);

  //       },
  //       error => {
  //         this.creating = false;
  //         this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ORG'));
  //       }
  //     );
  // }


}
